import { useLocation } from 'react-router-dom';
import { parseActionRouteParams } from './util';

const useParseActionRouteParams = <T = any>(): T => {
  const location = useLocation();
  const params = parseActionRouteParams(location.search || {}) as any;

  return params || {};
};

export default useParseActionRouteParams;
